<template>
  <div class="container" style="padding-top: 11em; padding-bottom: 27em">
    <CommunityItem v-for="(item, index) in dataList"
                   @click="onCommunityClick(index)"
                   @longClick="onCommunityLongClick(index)"
                   :item="item"
                   :num="(currentPage-1) * pageLimit + index + 1"
    >
    </CommunityItem>
    <CommunityDetailPopup
    :visible.sync="showDetail"
    :info="communitySelected"
    :onDelete="onDeleteItem"
    :onEdit="onEditItem"
    >
    </CommunityDetailPopup>
    <CommunityCreatePopup
      :visible.sync="showCreate"
      :info="communitySelected"
      :onEdit="onEdit"
    >
    </CommunityCreatePopup>
  </div>
</template>
<script>
import Utils from "../../../../config/utils";
import CommunityItem from "../../../controls/CommunityItem";
import CommunityDetailPopup from "../../../controls/popup/CommunityDetailPopup";
import CommunityCreatePopup from "../../../controls/popup/CommunityCreatePopup";
export default {
  name: "AdminWriteCommunity",
  components:{
    CommunityItem,
    CommunityDetailPopup,
    CommunityCreatePopup
  },
  data() {
    return {
      dataList:[],
      communitySelected:null,
      currentPage:1,
      pageLimit:0,
      showDetail:false,
      showCreate:false,
    }
  },
  props:["keyword","pageCnt","phone","searchType"],
  methods:{
    getList() {
      if (this.$store.getters.isLoading) {
        return;
      }
        Utils.requestGet(
          this.$c.API.Community.findCommunityList,
          {
            phone: this.phone.replaceAll('-', ''),
            page_num: this.currentPage,
            column: this.searchType,
            keyword: this.keyword,
          },
        ).then(result => {
          if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              this.dataList =  result.data.list.map(it => {
                it.f_select = false;
                return it;
              });
              this.pageLimit = result.data.limit;
            this.$emit('update:pageCnt',result.data.page_count);
          } else {
            Utils.toast(this, result.msg);
          }
        });
    },
    onEdit(){
      this.getList();
    },

    onCommunityClick(index) {
      if (this.dataList.some(it => {
        return it.f_select;
      })) {
        // there is selected cell by long click
        this.dataList = this.dataList.map((it, idx) => {
          if (index == idx) {
            it.f_select = !it.f_select;
          }
          return it;
        });
        return;
      }

      this.communitySelected = this.dataList[index];
      this.showDetail = true;

    },
    onEditItem(){
      this.showDetail=false;
      this.showCreate=true;
    },
    onCommunityLongClick(index){
      this.dataList = this.dataList.map((it, idx) => {
        if (index == idx) {
          it.f_select = true;
        }
        return it;
      });
    },
    getProfile() {
      Utils.requestGet(
        this.$c.API.User.getProfile,
        {}
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          this.myinfo.transformData(result.data);
          // this.myinfo.saveInfo();
          this.myinfo.loadInfo();
        } else {
        }
      });
    },
    onDeleteItem(){
        Utils.toast(this, this.$t('common.delete_success'));
        this.showDetail = false;
        this.dataList = this.dataList.filter(it => {
            return it.f_idx != this.communitySelected.f_idx;
          });
      }
  },
  mounted() {
    this.getList();
    this.getProfile();

  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/css/main/admin/Admin.scss';
@import '../../../../assets/css/_vars.scss';
</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/AdminWriteCommunity.vue